import React, { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import UploadImageField from "shared/components/Form/UploadImageField";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { useGameDetails } from "../../context";

const GameImages: FC = () => {
  const {
    imageLoadingStatus,
    backgroundFile,
    setBackgroundFile,
    logoFile,
    setLogoFile,
  } = useGameDetails();

  return (
    <ContentSection title="Settings">
      <FlexColumn rowGap={"1rem"}>
        <UploadImageField
          imageFile={backgroundFile}
          setImageFile={setBackgroundFile}
          label={"Background image"}
          isLoading={imageLoadingStatus.isBgImageLoaded}
        />
        <UploadImageField
          imageFile={logoFile}
          setImageFile={setLogoFile}
          label={"Game logo"}
          isLoading={imageLoadingStatus.isLogoImageLoaded}
        />
      </FlexColumn>
    </ContentSection>
  );
};

export default GameImages;
